module.exports = __webpack_public_path__ + "img/item_Story_13.96688d93.jpeg";